import React, { useRef, useState, useEffect } from 'react';
import ReactToPrint from 'react-to-print';
import axios from 'axios'
import { BASE_URL_PREBID } from '../../config/axios';
import { useParams } from 'react-router-dom';
import { formattedDateLong } from '../Criticalissue/Date'
import numberToWords from 'number-to-words';
import { toast } from 'react-toastify';
import { Modal, ToastContainer } from 'react-bootstrap';
import { formatCurrencyIndian, handleErrorToast } from '../custom';
import { Printer, PDFIcon } from '../AllSvg';

const DeleteInvoice = ({
  i,
  id,
  getInvoiceData
}) => {
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false); //loading logic
  // console.log(id)

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    setLoading(true); // loading logic
    try {
      console.log("Delete Expense Detail Api");
      let res = await axios.delete(
        `${BASE_URL_PREBID}/project/invoicedelete/${id}/`
      );

      if (res.status === 200) {
        await getInvoiceData("null");
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId)
    } finally {
      toast.dismiss(loadingToastId);
    }
  };
  console.log("id")
  console.log(id)
  console.log("i")
  console.log(i)

  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <button className="model-delete-button" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are You Sure, You want to Delete Performa Invoice : {i.pi_invoice_number}

          <div className="button-models">

            <button
              onClick={handleFormSubmitDelete}
              className="model-button model-button-delete"
            >
              Delete
            </button>
          </div>

        </Modal.Body>
      </Modal>
    </>
  );
};

const SalarySlip = React.forwardRef((props, ref) => {

  const [invoiceData, setInvoiceData] = useState({
    "project": {},
    "project_details": {},
    "client": {},
    "invoice": {},

  })


  let { id } = useParams();
  const [match, setMatch] = useState(false);
  const [word, setWord] = useState("");
  const invoiceGSTIN = "06AAHCC0747L1ZK";


  const getInvoiceData = async (id) => {
    try {
      const res = await axios.get(`${BASE_URL_PREBID}/project/invoicedetails/${id}/`);
      setInvoiceData(res.data)

      const firstTwoCharactersRGSTIN = res.data?.client?.gstin_number?.substring(0, 2);
      const firstTwoCharactersIGSTIN = invoiceGSTIN.substring(0, 2);
      setWord(numberToWords.toWords(res.data.invoice?.billamount))
      // const gstinMatch = firstTwoCharactersRGSTIN === firstTwoCharactersIGSTIN;
      if (firstTwoCharactersRGSTIN === firstTwoCharactersIGSTIN) {
        setMatch(true);
      }
    } catch (err) {
    }
  };


  useEffect(() => {
    getInvoiceData(id);



  }, []);
  const downloadAsPDF = async () => {
    console.log("clicked ")
    const invoiceElement = document.querySelector('#invoice-cont');
    console.log(invoiceElement, 'invoice')
    // 1. Create a canvas from the HTML element
    const canvas = await htmlToCanvas(invoiceElement);
    console.log(canvas, 'canvas')
    // 2. Convert canvas to PDF
    const pdfBlob = await canvasToPDF(canvas);
    console.log(pdfBlob, "pdfblob")
    // 3. Trigger download
    downloadBlob(pdfBlob, 'invoice.pdf');
  };

  // Helper: Convert HTML to Canvas (simplified)
  const htmlToCanvas = async (element) => {
    const canvas = document.createElement('canvas');
    const scale = 2; // Higher scale = better quality

    // Set canvas dimensions
    const width = element.offsetWidth * scale;
    const height = element.offsetHeight * scale;
    canvas.width = width;
    canvas.height = height;

    // Render HTML to canvas
    const ctx = canvas.getContext('2d');
    ctx.scale(scale, scale);

    // Use foreignObject to render HTML inside canvas
    const data = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
      <foreignObject width="100%" height="100%">
        <div xmlns="http://www.w3.org/1999/xhtml">
          ${element.innerHTML}
        </div>
      </foreignObject>
    </svg>
  `;

    const img = new Image();
    const svgBlob = new Blob([data], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(svgBlob);

    await new Promise((resolve) => {
      img.onload = () => {
        ctx.drawImage(img, 0, 0);
        URL.revokeObjectURL(url);
        resolve();
      };
      img.src = url;
    });

    return canvas;
  };

  // Helper: Convert Canvas to PDF Blob
  const canvasToPDF = (canvas) => {
    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(blob);
      }, 'application/pdf');
    });
  };

  // Helper: Download Blob as File
  const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  function isFirstTwoCharsSame(str1, str2) {
    if (typeof str1 !== 'string' || typeof str2 !== 'string') return false;

    const firstTwo1 = str1.slice(0, 2).toLowerCase();
    const firstTwo2 = str2.slice(0, 2).toLowerCase();

    return firstTwo1 === firstTwo2;
  }

  return (
    <>
      <button onClick={downloadAsPDF}>Download as PDF</button>
      {console.log(invoiceData?.invoice?.document, "document")}
      {invoiceData?.invoice?.document ?
        <a href={invoiceData?.invoice?.document}><PDFIcon /></a> : ""}
      <div className="invoice-container" id="invoice-cont" ref={ref}>
        <div className="invoice-container">
          <div className="invoice-header">
            <div className="invoice-header-left">
              <img
                src={invoiceData.invoice.sub_company_detail?.company_logo}
                alt="logo"
                className="invoice-logo"
              />
            </div>
            <div className="">
              <div className="company-name">{invoiceData.invoice.sub_company_detail?.company_name}</div>
              <div className="company-address" style={{ maxWidth: "250px" }}>
                {invoiceData.invoice.sub_company_detail?.company_address}
              </div>
              <div className="company-address" style={{ maxWidth: "250px" }}>
                {invoiceData.invoice.sub_company_detail?.contact_number}
              </div>
              <div className="company-address" style={{ maxWidth: "250px" }}>
                {invoiceData.invoice.sub_company_detail?.email}
              </div>

            </div>
          </div>
          <div className="invoice-title">TAX INVOICE</div>

          <div className="invoice-divider"></div>

          <div className="section-header">
            <div style={{ display: "flex ", alignItems: "center", justifyContent: "end" }}>
              <div className="section-title ">Invoice Date :</div>

              <div className="performa-table-cell">{formattedDateLong(invoiceData.invoice?.invoice_date)}

              </div>
            </div>

          </div>

          <div className="details-section" >
            <div style={{ width: "50%" }}>
              <div className="section-title">Recipient Details</div>
              <table className="performa-table">
                <tbody>
                  <tr>
                    <td className="section-title font-weight500 invoice-td">Name</td>
                    <td className="performa-table-cell font-weight700">{invoiceData.client.client_name}</td>
                  </tr>
                  <tr>
                    <td className="section-title font-weight500 invoice-td">Address</td>
                    <td className="performa-table-cell ">{invoiceData.client.address}</td>
                  </tr>
                  <tr>
                    <td className="section-title font-weight500 invoice-td">Email</td>
                    <td className="performa-table-cell">{invoiceData.client.email}</td>
                  </tr>
                  <tr>
                    <td className="section-title font-weight500 invoice-td">Contact No.</td>
                    <td className="performa-table-cell">{invoiceData.client.contact_number}</td>
                  </tr>
                  <tr>
                    <td className="section-title font-weight500 invoice-td">POS</td>
                    <td className="performa-table-cell">{invoiceData.client.pos}</td>
                  </tr>
                  <tr>
                    <td className="section-title font-weight500 invoice-td">GSTIN</td>
                    <td className="performa-table-cell">{invoiceData.client.gstin_number}</td>
                  </tr>
                  <tr>
                    <td className="section-title font-weight500 invoice-td">Wo Number</td>
                    <td className="performa-table-cell performa-table-cell ">{invoiceData.project_details?.wono}</td>
                  </tr>
                  <tr>
                    <td className="section-title font-weight500 invoice-td">Wo date</td>
                    <td className="performa-table-cell performa-table-cell ">
                      {formattedDateLong(invoiceData.project_details?.wo_date)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div style={{ width: "50%" }}>
              <div className="section-title">Invoice Detail</div>
              <table className="performa-table">
                <tbody>
                  <tr>
                    <td className="section-title font-weight500 invoice-td">Invoice no.</td>
                    <td className="performa-table-cell font-weight700">{invoiceData.invoice?.invoice_number}</td>
                  </tr>
                  <tr>
                    <td className="section-title font-weight500 invoice-td">Running Invoice</td>
                    <td className="performa-table-cell font-weight700 ">{invoiceData.invoice?.serial_number}</td>
                  </tr>
                  <tr>
                    <td className="section-title font-weight500 invoice-td">PI Ref</td>
                    <td className="performa-table-cell">{invoiceData.invoice?.pi_invoice_number}</td>
                  </tr>
                  {/* <tr>
                  <td className="section-title font-weight500">Invoice Date</td>
                  <td className="performa-table-cell">{formattedDateLong(invoiceData.invoice?.billing_date)}</td>
                </tr> */}
                  <tr>
                    <td className="section-title font-weight500 invoice-td">CIPL Project no.</td>
                    <td className="performa-table-cell">{invoiceData.project.prebid_prcode}</td>
                  </tr>
                  <tr>
                    <td className="section-title font-weight500 invoice-td ">Bank Name</td>
                    <td className="performa-table-cell ">{invoiceData.invoice.sub_company_detail?.bank_name}</td>
                  </tr>
                  <tr>
                    <td className="section-title font-weight500 invoice-td ">Branch Name</td>
                    <td className="performa-table-cell ">{invoiceData.invoice.sub_company_detail?.branch_name}</td>
                  </tr>
                  <tr>
                    <td className="section-title font-weight500 invoice-td">Account No.</td>
                    <td className="performa-table-cell ">{invoiceData.invoice.sub_company_detail?.account_number}</td>
                  </tr>
                  <tr>
                    <td className="section-title font-weight500 invoice-td">IFSC</td>
                    <td className="performa-table-cell ">{invoiceData.invoice.sub_company_detail?.ifsc_code}</td>
                  </tr>
                  <tr>
                    <td className="section-title font-weight500 invoice-td">GSTIN</td>
                    <td className="performa-table-cell">{invoiceGSTIN}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="invoice-divider"></div>

          <tr className="project-name-section">
            <td style={{ display: "flex", gap: "10px", margin: "10px 0" }}>
              <th>Name of Work: <span style={{ fontWeight: "500" }}>{invoiceData.project.project_name}</span> <span>- Pre Tender Engineering Services</span></th>
            </td>
          </tr>

          <div className="invoice-body">
            <table className="performa-table">
              <thead>
                <tr className="performa-table-header">
                  <th className="performa-table-cell column-small">Sn</th>
                  <th className="performa-table-cell column-large">Project Particulars</th>
                  <th className="performa-table-cell column-medium align-right">Work Order</th>
                  <th className="performa-table-cell column-amount align-right">Rate %</th>
                  <th className="performa-table-cell column-amount align-right">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr className="performa-table-row">
                  <td className="performa-table-cell column-small">{1}</td>
                  <td className="word-wrap-20vw column-large project-details">{invoiceData.invoice?.work_stages}</td>
                  <td className="performa-table-cell column-medium align-right">
                    {formatCurrencyIndian(invoiceData.project_details?.without_gst_amount)}
                  </td>
                  <td className="performa-table-cell column-amount">{invoiceData.invoice?.bill_percentage}%</td>
                  <td className="performa-table-cell-right column-amount performa-table-cell-center">
                    {formatCurrencyIndian(invoiceData.invoice?.wihoutgst_amount)}
                  </td>
                </tr>
                <tr>
                  <td colSpan={5} className=""></td>
                </tr>
              </tbody>
            </table>




            <div className="invoice-divider"></div>
            <table className="performa-table">
              <tbody>
                <tr>
                  <td colSpan={5} className=""></td>
                </tr>
                <tr>
                  <td className="performa-table-cell column-small"></td>
                  <td className="summary-label">
                    <b>Total Amount Before Tax</b>
                  </td>
                  <td className="performa-table-cell summary-value"></td>
                  <td className="performa-table-cell-right column-medium"></td>
                  <td className="performa-table-cell-right column-amount"></td>
                  <td className="performa-table-cell-right column-amount">
                    <b>{formatCurrencyIndian(invoiceData.invoice?.wihoutgst_amount)}</b>
                  </td>
                </tr>
                <tr className="performa-table-row">
                  <td className="performa-table-cell performa-table-header column-small"></td>
                  <td className="summary-label">
                    <b>Work Order Summary -</b>{" "}
                  </td>
                  <td className="performa-table-cell summary-value">
                    <b>Amount</b>{" "}
                  </td>
                  <td className="performa-table-cell-right column-medium">
                    <b className='summary-value'>IGST</b>
                  </td>
                  {/* <td className="performa-table-cell-right column-amount text-black">{!isFirstTwoCharsSame(invoiceData.client.gstin_number, invoiceGSTIN) ? '18%' : '0%'}</td> */}
                  <td className="performa-table-cell-right column-amount text-black">{!isFirstTwoCharsSame(invoiceData.client.gstin_number, invoiceGSTIN) ? "18%" : "---"}</td>
                  <td className="performa-table-cell column-amount">
                    {!isFirstTwoCharsSame(invoiceData.client.gstin_number, invoiceGSTIN) ? formatCurrencyIndian(invoiceData.invoice?.gst_amount) : "---"}
                  </td>
                </tr>
                <tr>
                  <td className="performa-table-cell column-small"></td>
                  <td className="summary-value">Total Value of Work Order</td>
                  <td className="performa-table-cell summary-value">
                    {formatCurrencyIndian(invoiceData.project_details?.without_gst_amount)}
                  </td>
                  <td className="performa-table-cell-right column-medium">
                    <b className='summary-value'>SGST</b>
                  </td>
                  <td className="performa-table-cell-right column-amount text-black">{isFirstTwoCharsSame(invoiceData.client.gstin_number, invoiceGSTIN) ? '9%' : '---'}</td>
                  <td className="performa-table-cell column-amount">
                    {isFirstTwoCharsSame(invoiceData.client.gstin_number, invoiceGSTIN) ? formatCurrencyIndian(invoiceData.invoice?.gst_amount / 2) : '---'}
                  </td>
                </tr>
                <tr>
                  <td className="performa-table-cell column-small"></td>
                  <td className="summary-value">Total Billing Up to Previous Invoice</td>
                  <td className="performa-table-cell summary-value">
                    {invoiceData.total_billing_up_to_previous < 0 ? "-" : invoiceData.total_billing_up_to_previous}
                  </td>
                  <td className="performa-table-cell-right column-medium">
                    <b className='summary-value'>CGST</b>
                  </td>
                  {/* <td className="performa-table-cell-right column-amount text-black">{!isFirstTwoCharsSame(invoiceData.client.gstin_number, invoiceGSTIN) ? '0%' : '9%'}</td> */}
                  <td className="performa-table-cell-right column-amount text-black">{isFirstTwoCharsSame(invoiceData.client.gstin_number, invoiceGSTIN) ? '9%' : '---'}</td>

                  <td className="performa-table-cell column-amount">
                    {isFirstTwoCharsSame(invoiceData.client.gstin_number, invoiceGSTIN) ? formatCurrencyIndian(invoiceData.invoice?.gst_amount / 2) : '---'}
                  </td>
                </tr>
                <tr>
                  <td className="performa-table-cell column-small"></td>
                  <td className="summary-value">Total Billing in Current Invoice</td>
                  <td className="performa-table-cell summary-value font-weight-normal">
                    {formatCurrencyIndian(invoiceData.invoice?.wihoutgst_amount)}
                  </td>
                  <td className="performa-table-cell-right column-medium">
                    <b className='summary-value'>Total Tax</b>
                  </td>
                  <td className="performa-table-cell-right column-amount"></td>
                  <td className="performa-table-cell column-amount">
                    {!isFirstTwoCharsSame(invoiceData.client.gstin_number, invoiceGSTIN) ? formatCurrencyIndian(invoiceData.invoice?.gst_amount) : (formatCurrencyIndian(invoiceData.invoice?.gst_amount / 2) + formatCurrencyIndian(invoiceData.invoice?.gst_amount / 2))}
                  </td>
                </tr>
                <tr>
                  <td className="performa-table-cell column-small"></td>
                  <td className="summary-value">
                    Balance to Bill
                  </td>
                  <td className="performa-table-cell summary-value font-weight-normal">
                    {invoiceData.balance_to_bill}
                  </td>
                  <td className="performa-table-cell-right column-medium"></td>
                  <td className="performa-table-cell-right column-amount"></td>
                  <td className="performa-table-cell-right column-amount"></td>
                </tr>
                <tr>
                  <td className="performa-table-cell column-small"></td>
                  <td className="summary-value">
                    Total Amount After Tax
                  </td>
                  <td className="performa-table-cell summary-value"></td>
                  <td className="performa-table-cell-right column-medium"></td>
                  <td className="performa-table-cell-right column-amount"></td>
                  <td className="performa-table-cell-right column-amount">
                    <b>{formatCurrencyIndian(invoiceData.invoice?.billamount)}</b>
                  </td>
                </tr>
              </tbody>
            </table>

            <tr className="performa-table-row">
              <td className="performa-table-cell column-small"> </td>
              <td className=" ">
                <b style={{ textTransform: "capitalize" }}>{word} Only</b>
              </td>
            </tr>
          </div>

          <div className="terms-section">
            <div>
              <th>Terms and Conditions:-</th>
              <h6 className="terms-item">1. Invoice is True and fair </h6>
              <h6 className="terms-item">2. All disputes belong to Haryana Jurisdiction </h6>
              <h6 className="terms-item">3. Payment Shall be made within 5 Date of Tax Invoice </h6>
              <h6 className="terms-item">4. We are Registered MSME Unit Vide No.- UDYAM-DL-11-0010217 </h6>
              <h6 className="terms-item">
                <b>5. This is Software generated Invoice no signature required</b>
              </h6>
            </div>
          </div>
        </div>
        <div className="print-background"></div>
      </div>
    </>
  );
});

const InvoicePage = () => {
  const ref = useRef();
  // const handlePrint = () => {
  //   const printContents = ref.current.innerHTML;
  //   const originalContents = document.body.innerHTML;

  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  //   window.location.reload(); // reloads to restore interactivity
  // };

  return (
    <div>
      {/* Your other components or content */}
      <ReactToPrint
        bodyClass="print-agreement"
        content={() => ref.current}
        trigger={() => (
          <button className='model-button model-button-black'>
            <Printer /> Print
          </button>
        )}
      />
      {/* <button onClick={handlePrint}>Download PDF</button> */}
      <SalarySlip ref={ref} />
    </div>
  );
};

export { InvoicePage, DeleteInvoice };